<template>
  <div class="termListItem" >
    <el-popover
          ref="popoverTargetRef"
          :width="popoverWidth"
          popper-class="customTerm-popover"
          placement="bottom-start"
          trigger="click"
          @show="onShow"
          v-if="beforeEnter()"
      >
      <template #reference>
        <div class="el-dropdown-term">
          <div style="font-size: 13px; font-weight: bold; color: #8C8C8C;" v-if="selectedTags.length == 0">
            {{$t("art_choose_title")}}
          </div>
          <div v-if="selectedTags.length > 0">
            <div class="select-title">{{ $t('art_use_choose').replace('*', selectedTags.length) }}</div>
          </div>
          <el-icon class="el-icon--right" style="font-size: 13px; font-weight: bold; color: #8C8C8C;">
            <arrow-down />
          </el-icon>
        </div>
      </template>
      <div class="termlist-item">
        <div class="search-box">
          <div class="input-box">
            <div class="input-temp">
              <i class="iconfont icon-icon_search" :style="`color:${inputChoose ? '#2690E1' : '#BFBFBF'}`" />
              <el-input ref="inputRef" class="no-border-input" v-model="searchInput" @blur="inputBlur" @focus="inputFocus" @input="onSearchInput" :placeholder="$t('lang_search')">
              </el-input>
            </div>
            <div class="tags">
              <el-tag
                style="margin: 5px 5px;color: #595959; border: 0px solid transparent;--el-tag-close-icon-color: red;"
                color="#F5F5F5"
                v-for="(tag, index) in selectedTags"
                :key="index"
                closable
                :hit="false"
                @close="removeTag(tag,index)"
                class="custom-tag"
              >
                {{ tag.termName }}
              </el-tag>
            </div>
          </div>
        </div>
        <!-- <div class="search-common">{{ $t('art-list-tips-commom') }}</div> -->
        <div class="searchItem">
          <div class="item" v-for="item in searchList" @click="(()=>{onTerm(item)})">
            <div class="item-title" :style="`color: ${selectedMap[item.id] ? '#2590E1' : '#595959'}`">
              {{item.termName}}
            </div>
            <i class="iconfont icon-icon_correct" v-show="selectedMap[item.id]"/>
          </div>
        </div>
        <div class="create-Item" v-if="searchList.length == 0 && searchInput.length == 0">
          <i class="iconfont icon-icon_blank_1" />
          <div class="blank-title">{{ $t('art_not_data') }}</div>
          <div class="blank-btns">
            <div class="blank-btn">
              <PDFStatsButton :radius="4" iconFont="icon-icon_add_1" iconFontColor="#FFFFFF" :minHeight="28" :title="$t(`art_create_title`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="12px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onCreateArt())"/>
            </div>
            <div v-if="hasPreset" class="blank-btn">
              <PDFStatsButton :radius="4" iconFont="icon-icon_glossary" iconFontColor="#2590E1" :minHeight="28" :title="$t(`art_preset_entry`)" :color="`#ffffff`" textColor="#2590E1" :borderStyle="'#2690E1 solid 1px'" customFontSize="12px" paddingTop="0 0" paddingH="0 0" @ButtonClick="(()=> onOpenPreset())"/>
            </div>
          </div>
        </div>
        <div class="create-Item" style="margin: 50px 0;" v-if="searchList.length == 0 && searchInput.length > 0">
          <i class="iconfont icon-icon_blank_1" />
          <div class="blank-title">{{ $t('art_not_data') }}</div>
        </div>
      </div>
    </el-popover>
    <div class="el-dropdown-term" v-if="!beforeEnter()" @click="onUpPro">
      <div style="font-size: 13px; font-weight: bold; color: #8C8C8C;" v-if="selectedTags.length == 0">
        {{$t("art_choose_title")}}
      </div>
      <div v-if="selectedTags.length > 0">
        <div class="select-title">{{ $t('art_use_choose').replace('*', selectedTags.length) }}</div>
      </div>
      <el-icon class="el-icon--right" style="font-size: 13px; font-weight: bold; color: #8C8C8C;">
        <arrow-down />
      </el-icon>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useI18n } from 'vue-i18n'
import TranslateServer from '@/services/TranslateServer';
const { t } = useI18n()
import useUserStore from "@/store/modules/user";
import {storeToRefs} from "pinia";
import { ArrowDown } from '@element-plus/icons-vue'
import PDFStatsButton from "@/components/Button/PDFStatsButton.vue"
import eventBus from 'vue3-eventbus'
import { useRouter, useRoute } from 'vue-router'
import Toast from "@/utils/toast";
import { checkPresetTermAvailable } from "@/composables/usePresetTermAvailable";

const userStore = useUserStore();
const router = useRouter()
const route = useRoute()
const selectedTags = ref<any[]>([])
const selectedMap = ref({})
const inputRef = ref()
const popoverTargetRef = ref<{ hide?: () => void } | null>(null)

let call = defineEmits(["onUpdataArt", "onUpPro",'onClose'])

const { token, userRights} = storeToRefs(userStore);

interface Props {
  width?: string | number,
  activeIds?: string
}
const props = withDefaults(defineProps<Props>(), {
  width: 800,
})

const popoverWidth = computed(() => {
  const value = typeof props.width === 'string' ? props.width.trim() : props.width
  const numericValue = Number(value)
  return Number.isFinite(numericValue) && numericValue > 0 ? numericValue : value || 800
})

let searchInput = ref("")
let inputChoose = ref(false)
let searchList = ref([])

const beforeEnter = () => {
  console.log('beforeEnter')
  // let currentConfig = userRights.value
  return true
  // if (!currentConfig.useTermTbFlag) {
  //   return false
  // }else {
  //   return true
  // }
};

function onUpPro(){
  console.log("onUpPro")
  call('onUpPro')
}

watch(
  () => props.activeIds,
  (newValue, oldValue) => { 
    // 监听 activeIds 变化后的处理逻辑
    if(newValue !== undefined && newValue !== ""){
      setTags(newValue, searchList.value)
    }
  }
)

function onShow() {
  console.log("onShow")
  onSearchInput()
  checkPreset()
}

const setTags = (strs:string,list:any[]) => {
  let ids:any[] = [];
  // 检查 strs 是否有值
  if (strs && strs.trim()) {
      // 拆分字符串为数组
      ids = strs.split(',').map(id => id.trim()); // 去除每个 ID 的空格
  }
  // 拆分字符串为数组
  // let ids = strs.split(',');
  // 用于存储匹配的对象
  let matchedObjects:any[] = [];
  // 遍历 ids 数组进行匹配
  ids.forEach(id => {
      // 转换为数字
      const numericId = parseInt(id.trim(), 10);
      
      // 在 objectsArray 中查找匹配的对象
      const matchedObject = list.find(obj => obj.id === numericId);
      
      // 如果找到匹配的对象，则存入 matchedObjects 数组
      if (matchedObject) {
          selectedTags.value.push(matchedObject);
          selectedMap.value[matchedObject.id] = matchedObject
      }
  });
}

function onSearchInput() {
  if (searchInput.value.length > 0) {
    TranslateServer.getRequestUserSearchTermlist({termName: searchInput.value}).then((data)=> {
      if (data.code == "1") {
        let list = data.list
        if (list && list.length > 0) {
          searchList.value = list
        }else {
          searchList.value = []
        }
      }
    }).catch((error)=>{
      searchList.value = []
    })
  }else {
    TranslateServer.getRequestUserSearchTermlist({}).then((data)=> {
      if (data.code == "1") {
        let list = data.list
        if (list && list.length > 0) {
          searchList.value = list
          if(props.activeIds !== undefined && props.activeIds !== ""){
            setTags(props.activeIds, searchList.value)
          }
        }else {
          searchList.value = []
        }
      }
    }).catch((error)=>{
      searchList.value = []
    })
  }

  updateInputWidth()
}

function updateInputWidth() {
  if (inputRef.value && selectedTags.value.length > 0) {
    const inputEl = inputRef.value.$el.querySelector('input');
    const span = document.createElement('span');
    span.style.visibility = 'hidden';
    span.style.whiteSpace = 'nowrap';
    span.style.position = 'absolute';
    span.style.padding = '0 0px'; // 考虑 padding
    span.innerText = searchInput.value || inputEl.placeholder;
    document.body.appendChild(span);
    const width = span.offsetWidth;
    document.body.removeChild(span);
    let div = document.getElementsByClassName("input-temp")
    if (width < 100) {
      inputEl.style.width = `${width}px`;
      div[0].style.width = `${100}px`;
      // div[0].style.width = `${width + 40}px`;
    }
  }else if (inputRef.value){
    const inputEl = inputRef.value.$el.querySelector('input');
    let div = document.getElementsByClassName("input-temp")
    // inputEl.style.width = `600px`;
    // div[0].style.width = `600px`;
  }
}

function inputBlur() {
  console.log("inputBlur")
  inputChoose.value = false
};

function inputFocus() {
  console.log("inputFocus")
  inputChoose.value = true
};

function onTerm(item, index) {
  if (selectedTags.value.length > 9) {
    Toast(t('art_choose_max_tip'))
    return
  }
  if (!selectedMap.value[item.id]) {
    selectedTags.value.push(item)
    selectedMap.value[item.id] = item
  }
  updateInputWidth()
  call('onUpdataArt', selectedTags.value)
}

function removeTag(item,index) {
  if (selectedMap.value[item.id]) {
    selectedTags.value.splice(index, 1)
    delete selectedMap.value[item.id]
  }
  updateInputWidth()
  call('onUpdataArt', selectedTags.value)
}

function onCreateArt() {
  popoverTargetRef.value?.hide?.()
  call('onClose')
  router.push({path: '/account', query: {menu: 'glossary'}})
  eventBus.emit("accountPush", 11)
}

const hasPreset = ref(false)
let presetChecked = false

function checkPreset() {
  if (presetChecked) return
  presetChecked = true
  checkPresetTermAvailable().then((available) => {
    hasPreset.value = available
  })
}

function onOpenPreset() {
  popoverTargetRef.value?.hide?.()
  call('onClose')
  router.push({ path: '/account', query: { menu: 'glossary', preset: 1 } })
  eventBus.emit('accountPush', 11)
}

onMounted(()=>{
  console.log("init term ===")
  if (token.value){
    onSearchInput()
    checkPreset()
  }
})

</script>

<style lang="scss">
.termListItem {
  display: flex;
  width: 100%;
  min-width: 0;
  height: 100%;
  flex-wrap: wrap;
}

.termlist-item {
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  .search-common {
    font-size: 12px;
    color: #8C8C8C;
  }
  .create-Item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon-icon_blank_1 {
      font-size: 48px;
      color: #BFBFBF;
    }
    .blank-title {
      font-size: 12px;
      color: #BFBFBF
    }
    .blank-btn {
      margin-top: 20px;
      min-width: 142px;
      height: 30px;
      margin-bottom: 20px;
    }
    .blank-btns {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      flex-wrap: wrap;
    }
  }
  .search-box {
    display: flex;
    flex-direction: row;
    width: 100%;
    border-bottom: 1px solid #eee;
    min-height: 36px;
    margin-bottom: 10px;
    position: relative;

    // align-items: center;
    .input-box {
      display: flex;
      min-height: 30px;
      flex-wrap: wrap;
      flex-direction: row;
      width: 100%;
      .input-temp {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        overflow: hidden;
        .icon-icon_search {
          // margin-top: 5px;
        }
        .no-border-input {
          min-height: 30px;
          font-size: 12px;
          border: 0;/*清除自带的2px的边框*/
          margin-left: 10px;
          outline: none;/*清除input点击之后的黑色边框*/
          background-color: transparent;
          color: var(--text-color);
        }
      }
      
      .tags {
        // margin-left: 10px;
        display: flex;
        flex-direction: row;
        // max-width: 500px;
        flex-wrap: wrap;
        // background-color: red;
        // overflow: hidden;
        // overflow-x: auto;
      }
    }
  }
  .searchItem {
    display: flex;
    flex-direction: row;
    padding: 5px 0;
    // min-height: 100px;
    max-height: 200px;
    width: 100%;
    overflow-y: auto;
    flex-wrap: wrap;
    .item {
      display: flex;
      flex-direction: row;
      padding: 10px 0;
      width: 20%;
      // width: 100%;
      cursor: pointer;
      font-size: 12px;
      height: 17px;
      color: var(--text-color3);
      align-items: center;
      .item-title {
        max-width: 80%;
        font-size: 12px;
        color: var(--text-color3);
        white-space: nowrap; /* 强制文字不换行 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 显示省略号 */
      }
      &:hover .item-title{
        color: var(--progress-bg-color)
      }
      .icon-icon_correct {
        font-size: 16px;
        margin-left: 5px;
        color: #2590E1;
      }
    }
    .notItem {
      display: flex;
      width: 100%;
      font-size: 12px;
      height: 17px;
      color: var(--text-color3);
      margin-bottom: 10px;
    }
  }
}

.el-dropdown-term {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
  cursor: pointer;
}
input::placeholder {
  color: #BFBFBF; /* 设置placeholder颜色为橙色 */
}

.select-title {
  color: #262626;
  font-size: 13px;
}
.custom-tag .el-icon-close {
  color: #BFBFBF; /* hover 状态下的颜色 */
}
.custom-tag .el-icon-close:hover {
  color: #BFBFBF; /* hover 状态下的颜色 */
}


</style>
<style scss scoped>
.termListItem input{
  font-size: 16px !important;
}

.customTerm-popover.el-popover{
  background-color: #FFFFFF !important;
  border-color: transparent !important;
  box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.16);
  max-height: 300px;
  .el-popper__arrow::before {
    background: #FFFFFF;
    border-color: transparent;
  }
}

</style>

<style scoped>
.no-border-input :deep(.el-input__wrapper) {
  box-shadow: none !important; /* 清除边框 */
  border: none !important; /* 确保没有边框 */
}

.no-border-input :deep(.el-input__wrapper:hover) {
  box-shadow: none !important; /* 清除 hover 状态下的边框 */
}

.no-border-input :deep(.el-input__wrapper.is-focus) {
  box-shadow: none !important; /* 清除聚焦状态下的边框 */
}

</style>
